<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>展厅详情</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-2 row-cols-md-2 row-cols-1">
		            <div class="col">
		                <div class="project-details-img-wrap">
		                    <div class="project-details-img mb-6" v-for="(item,index) in imgInfo" :key="index">
		                        <img :src="item | imgfilter" alt="Project Image">
		                    </div>
		                </div>
		            </div>
		            <div class="col sidebar-active">
		                <div class="project-wrapper-sticky">
		                    <div class="project-details-content mb-5 mb-md-8">
		                        <h5 style="color: #4A4A4A;">{{showInfo.name}}</h5>
		                        <div class="project-details-list-content"> 
		                            <span class="tag" v-for="(tag,tai) in showInfo.tags" :key="tai">{{tag}}</span>
		                        </div>
		                        <p>展厅地址：{{showInfo.address}}</p>
								<div class="d-flex" style="margin-top: 30px;justify-content: space-between;">
									<div class="d-flex" style="align-items: center;">
										<Icon class="c-00" v-if="showInfo.like_flag" style="cursor: pointer;" size="30" color="#ff495e" type="ios-heart" @click="collect(showInfo)" />
										<Icon class="c-00" v-else style="cursor: pointer;" size="30" type="ios-heart-outline" @click="collect(showInfo)" />
										<span style="margin-left: 10px;">{{showInfo.like_count}}</span>
									</div> 
									<div class="d-flex" style="align-items: center;">
										<Icon class="c-00" v-if="showInfo.save_flag" style="cursor: pointer;" size="30" color='#f8dd66' type="ios-star" @click="collectsave(showInfo)" />
										<Icon class="c-00" v-else style="cursor: pointer;" size="30" type="ios-star-outline" @click="collectsave(showInfo)" />
										<span style="margin-left: 10px;">{{showInfo.save_count}}</span>
									</div> 
									<div class="d-flex" style="align-items: center;">
										<Icon size="30" type="ios-chatboxes-outline" />
										<span style="margin-left: 10px;">{{projectProductList.length}}</span>
									</div>
								</div>
		                    </div>
		                    <div class="project-details-info modify">
								<h5 style="color: #4A4A4A;" class="title">所属商家</h5>
								<div style="margin-top: 20px;margin-left: 30px;">
									<div @click="toMerchant(merchantInfo)" style="cursor: pointer;">{{merchantInfo.name}}</div>
								</div>
		                    </div>
		                    <div class="social-icon-style mb-5 modify">
		                        <h5 class="title" style="margin-bottom: 20px;color: #4A4A4A;">展厅评论({{projectCommentList.length}})</h5>
								<div>
									<div class="pd-3" style="display: flex;">
										<Input type="textarea" v-model="commentText" placeholder="说点什么吧..." @on-enter="ShowCommentSave" />
										<Button style="margin-left: 10px;" type="primary" shape="circle" @click="ShowCommentSave">发送</Button>
									</div>
									<Scroll height='600'>
									<div class="comment" v-for="(res, index) in projectCommentList" :key="res.id">
										<div class="left">
											<img :src="res.avatar | imgfilter" style="width: 54px;height: 54px;"></img>
										</div>
										<div class="right">
											<div class="top">
												<div>
													<div class="f12">{{ res.nickname }}</div>
													<div class="f10 time">{{ res.add_time }}</div>
												</div>
												<div class="like" :class="{ highlight: res.like_flag }">
													<Icon style="cursor: pointer;" size="30" @click="clickLike(res)" :color="res.like_flag?'#009C44':''" type="md-thumbs-up" />
													<div class="num">{{ res.like_count }}</div>
												</div>
											</div>
											<div class="content f15" @click="replyPid(res)">{{ res.comment }}</div>
											<div class="reply-box">
												<div class="item flex-row" v-for="(item, index) in res.children" :key="item.index">
													<div class="left">
														<image :src="item.avatar" mode="aspectFill" style="width: 40rpx;height: 40rpx;"></image>
													</div>
													<div class="ml-1">
														<div class="username" style="line-height: 40rpx;">{{ item.nickname }}</div>
														<div class="text f12">{{ item.comment }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									</Scroll>
								</div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	import { getCookies } from '@/libs/util'
	import {
		getShowInfo,
		ShowLikeAdd,
		ShowLikeDel,
		getShowCommentList,
		ShowCommentSave,
		commentShowLikeAdd,
		commentShowLikeDel,
		CollectAdd,
		CollectDel
	 } from '@/api'
	 export default {
	   name: 'app',
	   data() {
			return {
				userInfo: {},
				pid: 0,
				commentText: '',
				bgImg: require('../../static/images/banner/banner-3.jpg'),
				imgInfo: [],
				showInfo: {},
				merchantInfo: {},
				
				projectProductList: [],
				projectCommentList: [],
			}
		},
		created() {
		    this.getShowInfo() 
		    this.getShowCommentList() 
		},
		mounted() {
			this.userInfo = this.$store.state.app.userInfo
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			
			toMerchant(data) {
				let routeUrl3 = this.$router.resolve({
					path: '/merchantDetail/'+data.zk_id,
				  })
				  window.open(routeUrl3.href, '_blank')
			},
			
			// 收藏
			collectsave(item) {
				let that = this
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if(item.save_flag){
					let param={
						type: 2,
						pr_id:item.id
					}
					CollectDel(param).then((res)=>{
						if(res.status==200){
							that.$message.success("取消收藏")
							item.save_flag = 0
							item.save_count--
						}
					})
				}else{
					let param={
						type: 2,
						pr_id:item.id
					}
					CollectAdd(param).then((res)=>{
						if(res.status==200){
							that.$message.success("收藏成功")
							item.save_flag = 1
							item.save_count++
						}
					})
				}
			},
			
			// 评论点赞
			clickLike(item) {
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				let that = this
				if(item.like_flag){
					let param={
						comment_id: item.id
					}
					commentShowLikeDel(param).then((res)=>{
						if(res.status==200){
							that.$message.success(res.msg)
							item.like_flag = 0
							item.like_count--
						}
					})
				}else{
					let param={
						comment_id: item.id
					}
					commentShowLikeAdd(param).then((res)=>{
						if(res.status==200){
							that.$message.success('点赞成功')
							item.like_flag = 1
							item.like_count++
						}
					})
				}
			},
			
			// 获取展厅详情
			async getShowInfo() {
			  const res = await getShowInfo({
				  id: this.$route.params.id
			  })
			  let data = res.data || {}
			  this.imgInfo = data.detail_image
			  
			  if(data.tags) data.tags = data.tags.split(',') || []
			  
			  this.merchantInfo = data.merchantInfo
			  this.showInfo = data
			},
			
			// 获取展厅产品
			async getProjectProductList() {
			  const res = await getProjectProductList({
				  project_id: this.$route.params.id
			  })
			  let data = res.data.data || []
			  this.projectProductList = data
			},
			
			// 展厅评论
			async ShowCommentSave() {
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				let that = this
				  await ShowCommentSave({
					  show_id: this.$route.params.id,
					  nickname: that.userInfo.nickname,
					  avatar: that.userInfo.avatar,
					  pid: that.pid,
					  comment: that.commentText
				  }).then(res => {
					  this.getShowCommentList()
					  that.commentText = ''
					  that.pid = 0
				  }).catch(err => {
					  
				  })
			},
			
			// 获取展厅评论
			async getShowCommentList() {
			  const res = await getShowCommentList({
				  show_id: this.$route.params.id
			  })
			  let data = res.data.list || []
			  this.projectCommentList = data
			},
			
			collect(item){
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if(item.like_flag == 0){
					ShowLikeAdd({
						show_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.like_flag= 1
							item.like_count++
						}
					})
				}else{
					ShowLikeDel({
						show_id:item.id
					}).then((res)=>{
						if(res.status==200){
							item.like_flag= 0
							item.like_count--
						}
					})
				}
			},
		}
	}
</script>

<style>
</style>
